export default "__VITE_ASSET__BFNuyBYY__"